//src/Components/Auth/CustomButton/index.tsx
import Spinner from 'Components/Spinner';

export interface CustomButtonProps {
  text?: string;
  suffix?: React.ReactNode;
  prefix?: React.ReactNode;
  borderColor?: string;
  textColor?: string;
  bgColor?: string;
  iconColor?: string;
  opacity?: number;
  bgColorHover?: string;
  textColorHover?: string;
  isActive?: boolean;
  type?: 'button' | 'submit' | 'reset';
  textSize?:
    | 'text-sm'
    | 'text-xs'
    | 'text-lg'
    | 'text-regular'
    | 'text-base'
    | 'text-medium'
    | 'text-tiny';
  height?: string;
  width?: string;
  font?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  loading?: boolean;
  children?: JSX.Element | string;
  form?: string;
  disabled?: boolean;
}

export const CustomButton = ({
  text,
  suffix,
  prefix,
  bgColorHover,
  textColorHover,
  borderColor = 'green',
  opacity = 100,
  textColor = 'white',
  bgColor = 'green',
  height = 'h-12',
  font = 'semibold',
  type,
  textSize = 'text-base',
  form,
  onClick,
  loading,
  isActive,
  disabled = false,
  children,
  width = 'w-full',
}: CustomButtonProps) => (
  <>
    <button
      form={form}
      disabled={loading || disabled}
      onClick={onClick}
      type={type}
      className={` disabled:opacity-50 ${disabled && 'cursor-default'} ${
        loading ? 'cursor-not-allowed' : ''
      } bg-${isActive ? bgColorHover : bgColor}  text-${
        isActive ? textColorHover : textColor
      }  bg-opacity-${opacity} ${width} gap-3 px-3 py-2 border-${borderColor} hover:bg-${bgColorHover} hover:text-${textColorHover} border rounded-lg flex items-center hover:shadow-lg outline-none focus:outline-none  ease-linear transition-all duration-150 ${height}`}
    >
      {prefix && <span className="">{prefix}</span>}
      {text && (
        <span className={`w-full font-${font} ${textSize}`}>{text}</span>
      )}
      {children}
      {suffix && <span className="">{suffix}</span>}
      {loading && <Spinner bounce={false} />}
    </button>
  </>
);

/* DO NOT DELETE COMMENT
PurgeCSS: 
  border-white
  bg-red-dark
  border-red-dark
*/
